import React from "react";
import rootStore from "../../../../stores/rootStore.js";
import {observer} from "mobx-react";
import {Badge, Card, Col, Row, Spinner} from "react-bootstrap";

function OrderSummary() {

    const taxCertOrderStore = rootStore.taxCertOrderStore;

    return (
        <Card className="shadow-sm order-summary-card">
            <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                <strong>Order Summary</strong>
                {taxCertOrderStore.taxAuthorityName && (
                    <Badge bg="light" text="dark">{taxCertOrderStore.taxAuthorityName}</Badge>
                )}
            </Card.Header>
            <Card.Body>
                {taxCertOrderStore.taxAuthorityId === null ? (
                    <div className="text-muted">Select a tax authority to see pricing details.</div>
                ) : (
                    <>
                        {taxCertOrderStore.loadingEstimate ? (
                            <div className="d-flex align-items-center">
                                <Spinner animation="border" size="sm" className="me-2" />
                                <span>Calculating estimate...</span>
                            </div>
                        ) : (
                            <div>
                                <Row className="mb-2">
                                    <Col xs={6} className="text-muted">Product</Col>
                                    <Col xs={6} className="text-end">{taxCertOrderStore.productName}</Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs={6} className="text-muted">Product Fee</Col>
                                    <Col xs={6} className="text-end">
                                        {taxCertOrderStore.productFee.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </Col>
                                </Row>
                                {taxCertOrderStore.searchType && (
                                    <>
                                        <Row className="mb-2">
                                            <Col xs={6} className="text-muted">Search Type</Col>
                                            <Col xs={6} className="text-end">{taxCertOrderStore.searchType.toUpperCase()}</Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col xs={6} className="text-muted">{taxCertOrderStore.searchType.toUpperCase()}</Col>
                                            <Col xs={6} className="text-end">{taxCertOrderStore.searchTerm}</Col>
                                        </Row>
                                    </>
                                )}
                                <Row className="mb-2">
                                    <Col xs={6} className="text-muted">Service Fee</Col>
                                    <Col xs={6} className="text-end">
                                        {taxCertOrderStore.serviceFee.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </Col>
                                </Row>
                                <Row className="mb-2">
                                    <Col xs={6} className="text-muted">Taxes</Col>
                                    <Col xs={6} className="text-end">
                                        {taxCertOrderStore.totalTaxes.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </Col>
                                </Row>
                                <hr/>
                                <Row>
                                    <Col xs={6}><strong>Total</strong></Col>
                                    <Col xs={6} className="text-end">
                                        <strong>
                                            {taxCertOrderStore.total.toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "USD",
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </strong>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </>
                )}
            </Card.Body>
        </Card>
    )
}

export default observer(OrderSummary);
